<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
		//Design system components
	import { Checkbox, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { Request } from '../../../../types/requests/request';
	import type { Device } from '../../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore?.thermostats[0]?.target_t,
		setTargetTemperature = async (): Promise<Request> => {
			if (enabled == settings?.enabled) return { isok: true };
			return await postReq(
				`/device/generic_command`,
				{
					id,
					command: `target_t`,
					payload: JSON.stringify({
						id: device.channel,
						enabled,
					}),
				},
				20000,
			);
		},
		setAcceleratedHeating = async (): Promise<Request> => {
			if (!enabled && accelerated_heating == settings?.accelerated_heating) return { isok: true };
			return await postReq(
				`/device/generic_command`,
				{
					id,
					command: `target_t`,
					payload: JSON.stringify({
						id: device.channel,
						accelerated_heating,
					}),
				},
				20000,
			);
		},
		save = async () => {
			waitForResponse = true;
			const res: SettingRequest[] = await Promise.all([
				setTargetTemperature(),
				setAcceleratedHeating(),
			]);
			onSettingsResponse(res, device);
			waitForResponse = false;
		};

	let enabled = settings?.enabled,
		accelerated_heating = settings?.accelerated_heating,
		waitForResponse = false;
</script>

<Checkbox class="mb-s" size="m" bind:checked={enabled} id="checkbox-06wi324"
	>{$format('trv_auto_description', {
		default: 'Enable automatic temperature control',
	})}</Checkbox
>

{#if enabled}
	<Checkbox class="mb-s" size="m" bind:checked={accelerated_heating} id="checkbox-w054iie"
		>{$format('trv_acc_heat_description', {
			default: 'Accelerated heating (reduce time to reach the target temperature)',
		})}</Checkbox
	>
{/if}

<Button size="m" width="full" loading={waitForResponse} on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
